<div class="p-6">
    <h2 class="text-xl font-semibold mb-4">Complete Batch Rollover</h2>

    @if (!completed) {
    <form [formGroup]="rolloverForm" (ngSubmit)="onSubmit()">
        <div class="mb-6">
            <p class="mb-4">
                Please select a date and time to rollover the selected contracts.
                This will process {{data.docketIds.length}} contract(s).
            </p>

            <mat-form-field class="w-full">
                <mat-label>Rollover Date & Time</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="rolloverDate" [max]="maxDate" required>
                <mat-hint>The rollover date must be in the past</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>

                @if (rolloverForm.get('rolloverDate')?.hasError('futureDate') &&
                rolloverForm.get('rolloverDate')?.touched) {
                <mat-error>Rollover date cannot be in the future</mat-error>
                }
            </mat-form-field>
        </div>

        @if (processing) {
        <div class="mb-6">
            <p class="mb-2">Processing docket {{currentProcessingIndex + 1}} of {{data.docketIds.length}}...</p>
            <mat-progress-bar mode="determinate" [value]="getProgressPercentage()"></mat-progress-bar>
        </div>

        <div class="max-h-60 overflow-y-auto border rounded p-2 mb-4">
            @for (result of results; track result.docketId) {
            <div class="flex items-center p-2 border-b" [ngClass]="{
              'bg-blue-50': result.status === 'processing',
              'bg-green-50': result.status === 'success',
              'bg-red-50': result.status === 'error'
            }">
                <span class="mr-2">Docket #{{result.docketId}}:</span>

                @if (result.status === 'processing') {
                <mat-icon class="text-blue-500">hourglass_empty</mat-icon>
                } @else if (result.status === 'success') {
                <mat-icon class="text-green-500">check_circle</mat-icon>
                } @else {
                <mat-icon class="text-red-500">error</mat-icon>
                }

                <span class="ml-2">{{result.message}}</span>
            </div>
            }
        </div>
        }

        <div class="flex justify-end space-x-2">
            <button type="button" mat-button (click)="onCancel()" [disabled]="processing">
                Cancel
            </button>
            <button type="submit" mat-raised-button color="primary" [disabled]="rolloverForm.invalid || processing">
                Process Rollover
            </button>
        </div>
    </form>
    }

    @if (completed) {
    <div class="mb-6">
        <h3 class="text-lg font-medium mb-2">Rollover Complete</h3>

        <div class="max-h-60 overflow-y-auto border rounded p-2 mb-4">
            @for (result of results; track result.docketId) {
            <div class="flex items-center p-2 border-b" [ngClass]="{
            'bg-green-50': result.status === 'success',
            'bg-red-50': result.status === 'error'
          }">
                <span class="mr-2">Contract #{{result.docketId}}:</span>

                @if (result.status === 'success') {
                <mat-icon class="text-green-500">check_circle</mat-icon>
                } @else {
                <mat-icon class="text-red-500">error</mat-icon>
                }

                <span class="ml-2">{{result.message}}</span>
            </div>
            }
        </div>

        <div class="flex justify-between mt-4">
            <div>
                <span class="font-medium">Summary:</span>
                <span class="ml-2">
                    {{finalResultSuccess}} successful,
                    {{finalResultError}} failed
                </span>
            </div>
            <button mat-raised-button color="primary" (click)="close(completed)">Close</button>
        </div>
    </div>
    }
</div>